import { baseUrl } from './api.url.constants'
export * from './api.status.constants'
export * from './api.url.constants'
export * from './applicationPdfDocuments'
export * from './channel.constants'
export * from './contractor.input.visibility.type'
export * from './contractor.sections'
export * from './input.type.constants'
export * from './loan.bytepro.constants'
export * from './loan.constants'
export * from './loan.input.visibility.type'
export * from './loan.status.constants'
export * from './loan.type.constants'
export * from './payment.constant'
export * from './register-form.constants'
export * from './servicingEmails'
export * from './user.type.constants'

export const itemCountPerPage = 10
export const pullCreditReportLimitDays = 30
export const TimeZone = 'America/New_York'

export const daysOfWeek: Record<number, string> = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
}

export const monthOption: Record<number, string> = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
}

export const monthsInYear: Record<number, string> = {
  0: '',
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
  13: 'Closing Date',
}

export interface BaseFile {
  id: number
  name: string
  fileKey: string
  createdAt: number
}

export * from './company.constants'

import { COMPANY_NAME_FC } from './company.constants'

export const companyName = COMPANY_NAME_FC

export const appApiUrl = baseUrl

export const SecPerDay = 24 * 3600 * 1000

export enum SettingKey {
  CONDITION_NO = 'CONDITION_NO',
  CONDITION_TEMPLATE_NO = 'CONDITION_TEMPLATE_NO',
  TASK_TEMPLATE_NO = 'TASK_TEMPLATE_NO',
  ROLODEX_NO = 'ROLODEX_NO',
  LOAN_NO = 'LOAN_NO',
  TASK_NO = 'TASK_NO',
  ASSIGNMENT_NAMES = 'ASSIGNMENT_NAMES',
  FLOOR_NO = 'FLOOR_NO',
  BUSINESS_DAYS = 'BUSINESS_DAYS',
  RATESHEET_NO = 'RATESHEET_NO',
  COMPANY_BROADCAST = 'COMPANY_BROADCAST',
  BROKER_VERIFICATION = 'BROKER_VERIFICATION',
  CORRESPONDENT_VERIFICATION = 'CORRESPONDENT_VERIFICATION',
  TABLEFUNDER_VERIFICATION = 'TABLEFUNDER_VERIFICATION',
  BUSINESS_HOURS = 'BUSINESS_HOURS',
  REVIEW_FORM_CATEGORIES = 'REVIEW_FORM_CATEGORIES',
  REVIEW_FORM_TEMPLATE_NO = 'REVIEW_FORM_TEMPLATE_NO',
  ARM_DETAIL_NO = 'ARM_DETAIL_NO',
  LOAN_PROGRAM_NO = 'LOAN_PROGRAM_NO',
  DATAVERIFY_TEST_LOANNUMBER = 'DATAVERIFY_TEST_LOANNUMBER',
  DATAVERIFY_TEST_CODE = 'DATAVERIFY_TEST_CODE',
  SERVICE_NOTES_ORDER = 'SERVICE_NOTES_ORDER',
  SERVICE_NOTES_ORDER_ADDITIONAL = 'SERVICE_NOTES_ORDER_ADDITIONAL',
  BUDGET_ITEMS_MAPPING = 'BUDGET_ITEMS_MAPPING',
  BUDGET_TEMPLATE = 'BUDGET_TEMPLATE',
  BORROWER_CONDITIONS = 'BORROWER_CONDITIONS',
  HOMEPAGE_CREDIT_BOX = 'HOMEPAGE_CREDIT_BOX',
  CONTRACTOR_NO = 'CONTRACTOR_NO',
  GENERATE_DOCUMENT_NO = 'GENERATE_DOCUMENT_NO',
  ACCOUNTING_CATEGORIES = 'ACCOUNTING_CATEGORIES',
  DOCMAGIC_WORKSHEET_ID = 'DOCMAGIC_WORKSHEET_ID',
  GLOBAL_SETTINGS = 'globalSettings',
  LOAN_TERM_SHEET = 'LOAN_TERM_SHEET',
  UNDERWRITING_FEE = 'UNDERWRITING_FEE',
  BORROWER_NO = 'BORROWER_NO',
  LOAN_FIELD_PROPS = 'LOAN_FIELD_PROPS',
  RESTRUCTURE_LOAN_RELEASE = 'RESTRUCTURE_LOAN_RELEASE',
  LOAN_STATUS_LABEL = 'LOAN_STATUS_LABEL',
  TEXT_CONFIGURATION = 'TEXT_CONFIGURATION',
  FROM_EMAILS = 'FROM_EMAILS',
  CONDITION_TYPE_OPTIONS = 'CONDITION_TYPE_OPTIONS',
  DOCUMENT_CATEGORY_OPTIONS = 'DOCUMENT_CATEGORY_OPTIONS',
  UW_SUMMARY_CONFIG = 'UW_SUMMARY_CONFIG',
  FORM_DEFAULTS = 'FORM_DEFAULTS',
  DOCUMENT_GENERATE_DEFAULTS = 'DOCUMENT_GENERATE_DEFAULTS',
  TERM_SHEET_SIGN_MESSAGE = 'TERM_SHEET_SIGN_MESSAGE',
  PAYMENT_CODE = 'PAYMENT_CODE',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  ACCOUNT_PAYEES = 'ACCOUNT_PAYEES',
  ACCOUNT_SECTIONS = 'ACCOUNT_SECTIONS',
  ACCOUNTING_ACCOUNT_TYPES = 'ACCOUNTING_ACCOUNT_TYPES',
  LOAN_APPLICATION_PDF_DOCUMENTS = 'LOAN_APPLICATION_PDF_DOCUMENTS_V2',
}

export const GOOGLE_MAP_API_KEY = 'AIzaSyA2TV23UkRc7jDyLklenO902VTvnECVBOU'

export type EmailValue = Record<string, '' | 'to' | 'cc' | 'bcc'>

const windowsOrigin = window.location.origin
export const LinkDirectory: Record<string, string> = {
  'Admin Portal': `${windowsOrigin}/`,
  'Borrower Portal': `${window.location.origin}/borrowerlogin`,
  'Third Party Portal': `${windowsOrigin}/login`,
  'Quick Quote': `${windowsOrigin}/new`,
  'Share Scenario': `${windowsOrigin}/loan_process/structure/new`,
}
